import { Component, OnInit } from '@angular/core';

import 'rxjs/add/operator/switchMap';

@Component({
	selector: 'home',
	template:'<div> <navigation></navigation><top-details></top-details><description></description><top-gallery></top-gallery><restaurant-menu></restaurant-menu><restaurant-book></restaurant-book><event-book></event-book><reviews></reviews><contact-us></contact-us><timetable-location></timetable-location><footer></footer></div>',
	styleUrls: ['./home.component.css']
})

export class HomeComponent {
 deviceInfo = null;
        device = "unknown";
	constructor(
		
   
  	) {}
}


// WEBPACK FOOTER //
// /Users/kala/Sites/weeloy_website_engine/website-new-template-fun/src/app/home.component.ts